import { Box, ColorOptions, Spacer, TextNew } from '@jfs/ui-new'
import { capitalizeTxnDetailsKeys, Colors } from '../../util/util'
import styles from './styles'

const colorMap = {
  SUCCESS: 'GREEN',
  FAILED: 'ERROR',
  INPROCESS: 'ORANGE',
  ['REFUND ACCEPTED']: 'GREEN',
  ['REFUND FAILED']: 'ERROR',
  none: 'BLACK_21',
}

const getColor = (item: any) => {
  if (item.key === 'status') {
    return colorMap[(item.value as keyof typeof colorMap) || 'none']
  }
  return '#212121'
}

export const TextLayout = ({ title, data }) => {
  if (!data) {
    return null
  }
  const keys = [
    'paymentMode',
    'originalTransactionId',
    'utrNumber',
    'paymentType',
    'amount',
    'acquirerTerminal',
    'accountNumber',
    'issRefData',
    'invoice',
    'customerName',
    'failureMessage',
  ]
  const finalData: Array<any> = []

  keys?.map((item, index) => {
    const retData = {
      key: item,
      value: item === 'amount' ? `₹${data?.[item]}` : data?.[item],
    }
    if (data?.[item]) {
      finalData.push(retData)
    }
  })
  const RenderListItem = ({ item, index }: { item: any; index: number }) => {
    if (item?.value?.length === 0 || item?.value === 'NA' || item?.value === '₹ 0' || item?.value === '₹ 0.0') {
      return null
    }
    return (
      <Box {...styles.listItemContainer} paddingBottom={10} key={index + title}>
        <Box flex={0.4}>
          <TextNew
            color={'#757575' as ColorOptions}
            fontSize={14}
            fontFamily={'JioType-Medium'}
            lineHeight={20}
            letterSpacing={-0.07}>
            {capitalizeTxnDetailsKeys[item.key]}
          </TextNew>
        </Box>
        <Spacer size={16} direction={'horizontal'} />
        <Box flex={0.6} align={'flex-start'}>
          <TextNew
            lineHeight={20}
            fontSize={14}
            letterSpacing={-0.07}
            selectable
            fontFamily="JioType-Medium"
            color={getColor(item) as ColorOptions}
            textAlign={'left'}>
            {item?.value !== 'undefined' ? String(item?.value ?? 'NA') : 'NA'}
          </TextNew>
        </Box>
      </Box>
    )
  }
  return (
    <Box key={'textlayout_' + title}>
      <TextNew
        fontFamily={'JioType-Bold'}
        fontSize={16}
        lineHeight={24}
        fontWeight={'700'}
        letterSpacing={-0.09}
        color={Colors.BLACK_14 as ColorOptions}>
        {title}
      </TextNew>
      <Spacer size={16} />
      {/* <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={finalData}
        hide={false}
        isCustom={true}
        keyExtractor={(item, index) => String(item.id) + index}
        RenderCustomElement={renderListItem}
      /> */}
      {finalData?.map((item: any, index: any) => {
        return <RenderListItem item={item} index={index} key={index + title} />
      })}
    </Box>
  )
}
